import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import '../Alumnos/AlumnoForm.css';
import '../Alumnos/MDAlumnos.css';
import * as constantClass from '../fileWithConstants';
import { MdTableCell } from '../common/MdRowActions';

function BackIcon() {
  return (
    <svg className="md-page__icon md-page__icon--sm" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  );
}

function formatTipoActa(tipoActa) {
  if (tipoActa === 'R') return 'Regular';
  if (tipoActa === 'L') return 'Libre';
  if (tipoActa === 'E') return 'Equivalencia';
  return '';
}

function obtenerNota(nota) {
  switch (nota) {
    case 1: return '1 (uno)';
    case 2: return '2 (dos)';
    case 3: return '3 (tres)';
    case 4: return '4 (cuatro)';
    case 5: return '5 (cinco)';
    case 6: return '6 (seis)';
    case 7: return '7 (siete)';
    case 8: return '8 (ocho)';
    case 9: return '9 (nueve)';
    case 10: return '10 (diez)';
    default: return '';
  }
}

function getResultadoBadgeClass(resultado) {
  const value = (resultado || '').trim();
  if (value === 'Aprobó' || value === 'Aprobado') {
    return 'md-page__badge md-page__badge--success';
  }
  if (value === 'Reprobó' || value === 'Reprobado') {
    return 'md-page__badge md-page__badge--danger';
  }
  if (value === 'Ausente') {
    return 'md-page__badge md-page__badge--neutral';
  }
  return 'md-page__badge md-page__badge--neutral';
}

export class VerActaExamen extends Component {
  static displayName = VerActaExamen.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      loadError: '',
      searchData: [],
      alumnos: [],
      materia: '',
      id: this.props.match.params.id,
      folio: '',
      libro: '',
      fechaExamen: new Date().toString(),
      tipoActa: '',
    };
  }

  componentDidMount() {
    const canAccess = constantClass.canAccess('WWActasExamen');
    if (canAccess) {
      this.populateData();
    } else {
      this.setState({ loading: false });
    }
  }

  renderTable(alumnos) {
    if (!alumnos.length) {
      return <p className="md-form-page__empty-hint">No hay alumnos en esta acta.</p>;
    }

    return (
      <div className="md-page__table-card">
        <table className="md-page__table" aria-labelledby="ver-acta-examen-title">
          <thead>
            <tr>
              <th scope="col">DNI</th>
              <th scope="col">Nombre y Apellido</th>
              <th scope="col">Nota Examen Oral</th>
              <th scope="col">Nota Examen Escrito</th>
              <th scope="col">Nota Examen Promedio</th>
              <th scope="col">Resultado</th>
            </tr>
          </thead>
          <tbody>
            {alumnos.map((alumno) => (
              <tr key={alumno.detalleActaCod}>
                <MdTableCell>{alumno.alumnoDni}</MdTableCell>
                <MdTableCell>{alumno.alumnoNombre}</MdTableCell>
                <MdTableCell>{obtenerNota(alumno.detalleActaOral)}</MdTableCell>
                <MdTableCell>{obtenerNota(alumno.detalleActaEscrito)}</MdTableCell>
                <MdTableCell>{obtenerNota(alumno.detalleActaNota)}</MdTableCell>
                <td>
                  <span className={getResultadoBadgeClass(alumno.detalleActaResultado)}>
                    {alumno.detalleActaResultado || 'Sin resultado'}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    const {
      loading,
      loadError,
      searchData,
      materia,
      tipoActa,
      fechaExamen,
      libro,
      folio,
    } = this.state;

    const contents = loading
      ? <p className="md-page__loading"><em>Cargando datos...</em></p>
      : this.renderTable(searchData);

    return (
      <div className="md-page md-form-page md-ver-acta-examen">
        <Link className="md-form-page__back" to="/md-aex">
          <BackIcon />
          Volver al listado
        </Link>

        <h1 id="ver-acta-examen-title" className="md-form-page__title">Ver Acta de Examen</h1>

        {materia ? (
          <p className="md-form-page__subtitle">
            Materia: {materia}
            {' · '}
            Tipo acta: {formatTipoActa(tipoActa)}
            {' · '}
            Fecha examen: {constantClass.formatDisplayDate(fechaExamen)}
            {' · '}
            Libro: {libro} · Folio: {folio}
          </p>
        ) : null}

        <div className="md-form-page__feedback" aria-live="polite" role="status">
          {loadError ? (
            <div className="md-form-page__error" role="alert">{loadError}</div>
          ) : null}
        </div>

        {contents}
      </div>
    );
  }

  async populateData() {
    this.setState({ loading: true, loadError: '' });

    const { data } = await constantClass.apiFetch('api/aex/detalle/' + this.state.id, {
      method: 'GET',
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data)) {
      this.setState({
        loading: false,
        loadError: constantClass.getApiErrorMessage(
          data,
          'No se pudo cargar el detalle del acta.'
        ),
      });
      return;
    }

    this.setState({
      alumnos: data.returnModel,
      folio: data.returnModel[0].actaExamenFolio,
      libro: data.returnModel[0].actaExamenLibro,
      materia: data.returnModel[0].materiaCarreraNombre.trim() + ' - ' + data.returnModel[0].carreraNombre.trim(),
      searchData: data.returnModel,
      fechaExamen: data.returnModel[0].mesaExamenFechaExamen,
      tipoActa: data.returnModel[0].actaExamenTipo,
      loading: false,
    });
  }
}
